import ContractRejected from './ContractRejected';

export default ContractRejected;
